import {api, useMutationQuery} from 'base'

export const useGetTestData = () =>
  useMutationQuery<any, any, any>('getTestData', async (values) => {
    const {data} = await api.post('/project/test', values)
    return data.data
  })
